import { lookupProductData } from './lookupProductData';
import { storeProductData } from './storeProductData';

// TRACKING EVENTS
window.dataLayer = window.dataLayer || [];
var _learnq = _learnq || [];
// dataLayer.push({ ecommerce: null });

// Override the usual datalayer function to console log for testing
// (function() {
//   var originalPush = window.dataLayer.push;

//   window.dataLayer.push = function() {
//     console.log('dataLayer push:',arguments);

//     // Call the original push method
//     return originalPush.apply(this, arguments);
//   };
// })();

function observeSections() {
  const sectionTitles = document.querySelectorAll('[data-section-title]:not(.collection-grid[data-section-title], .search-grid[data-section-title])');
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const sectionTitle = entry.target.getAttribute('data-section-title');
        const productCards = entry.target.querySelectorAll('.product-card[data-product-id]');

        localStorage.removeItem('trackedProductCardIds');
        let productCardIds = [];

        productCards.forEach((productCard, index) => {
          const productId = productCard.getAttribute('data-product-id');
          const existingProductIndex = productCardIds.findIndex((item) => item.id === productId);

          if (existingProductIndex !== -1) {
            productCardIds[existingProductIndex] = { section: sectionTitle, id: productId, index: index };
          } else {
            productCardIds.push({ section: sectionTitle, id: productId, index: index });
          }

          const productsStore = JSON.parse(localStorage.getItem('products')) || {};
          const product = productsStore[parseInt(productId)]; // Access product by ID from the object
          if (product) {
            if (sectionTitle) {
              product.item_list_id = sectionTitle;
              product.item_list_name = sectionTitle.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
            }
            product.index = index; // Add the index to the product object
            product.quantity = 1;
            localStorage.setItem('products', JSON.stringify(productsStore));
            // console.log(`Product with ID "${productId}" updated in localStorage.`);
          } else {
            // console.log(`Product with ID "${productId}" not found in localStorage.`);
          }
        });

        // Perform necessary actions when the section title comes into view
        // console.log(`Section title "${sectionTitle}" is now visible.`);
        localStorage.setItem('trackedProductCardIds', JSON.stringify(productCardIds));
        trackedProductList();
        localStorage.removeItem('trackedProductCardIds');

        // After all actions for the sectionTitle have been executed
        obs.unobserve(entry.target); // Stop observing the current section
      }
    });
  });

  sectionTitles.forEach((sectionTitle) => {
    observer.observe(sectionTitle);
  });

  // return productCardIds; // Return the array of data-product-id attributes
}

function observeReviewsSection() {
  const reviewsSection = document.querySelector('.trustpilot-widget, .top-reviews');
  let hasPushedEvent = false;

  if (reviewsSection) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !hasPushedEvent) {
          setTimeout(() => {
            dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: "reviews_widget_viewed",
              ecommerce: {
                product_id: window.QF.product.id,
                variant_id: window.QF.variant_id,
                sku: window.QF.sku,
                number_of_stars: window.QF.number_of_stars,
                number_of_reviews: window.QF.number_of_reviews
              }
            });
            hasPushedEvent = true;
          }, 5000);
        }
      });
    });

    observer.observe(reviewsSection);
  }
}

function trustpilotReviewStars(){
  const reviewStars = document.querySelector('[trustpilot-review-stars]');

  reviewStars.addEventListener('click', function() {
    dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "reviews_stars_clicked",
      ecommerce: {
        product_id: window.QF.product.id,
        variant_id: window.QF.variant_id,
        sku: window.QF.sku,
        number_of_stars: window.QF.number_of_stars,
        number_of_reviews: window.QF.number_of_reviews
      }
    });
  });
}

function fetchProductCards() {
  const collectionGrid = document.querySelector('.collection-grid');
  const searchGrid = document.querySelector('.search-grid');

  // Reusable function to observe product cards in a grid
  const ProductGrid = (grid) => {
    if (grid) {
      // alert('Run fetchProductCards function');
      const productCards = grid.querySelectorAll('.product-card[data-product-id]');
      const sectionTitle = grid.getAttribute('data-section-title');
      let productCardIds = [];

      productCards.forEach((productCard, index) => {
        const productId = productCard.getAttribute('data-product-id');
        const existingProductIndex = productCardIds.findIndex((item) => item.id === productId);

        if (existingProductIndex !== -1) {
          productCardIds[existingProductIndex] = { section: sectionTitle, id: productId, index: index };
        } else {
          productCardIds.push({ section: sectionTitle, id: productId, index: index });
        }

        // console.log(`Product ID "${productId}" is in section "${sectionTitle}" at index ${index}.`);
        localStorage.setItem('trackedProductCardIds', JSON.stringify(productCardIds));

        // Assuming `productId` and `sectionTitle` are defined in the current scope
        const productsStore = JSON.parse(localStorage.getItem('products')) || {};
        const product = productsStore[parseInt(productId)]; // Access product by ID from the object
        if (product) {
          if (sectionTitle) {
            product.item_list_id = sectionTitle;
            product.item_list_name = sectionTitle.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
          }
          product.quantity = 1;
          localStorage.setItem('products', JSON.stringify(productsStore));
          //console.log(`Product with ID "${productId}" updated in localStorage.`);
        } else {
          //console.log(`Product with ID "${productId}" not found in localStorage.`);
        }
      });
      trackedProductList();
    }
  };
  // Call ProductGrid for each grid with the appropriate section title attribute
  ProductGrid(collectionGrid);
  ProductGrid(searchGrid); // Replace with the correct attribute for the searchGrid if it's different
  localStorage.removeItem('trackedProductCardIds');
}

window.addEventListener('load', () => {
  // Clear the trackedProductCardIds array on page load
  // localStorage.removeItem('trackedProductCardIds');

  // Call the function to start observing product cards
  storeProductData().then(() => {
    observeSections();
    fetchProductCards();
    // trackedProductList();
  });

  if (window.template === 'product') {
    trustpilotReviewStars();
    observeReviewsSection();
  }
});

document.addEventListener("loaded_more_products", function() {
  localStorage.removeItem('trackedProductCardIds');
  // Retrieve the new productCards
  fetchProductCards();
  // trackedProductList();
  // console.log("loaded more products");
});

function trackedProductList() {
  // alert('Run trackedProductList function');
  let trackedProductCardIds = JSON.parse(localStorage.getItem('trackedProductCardIds')) || [];
  let trackedProducts = trackedProductCardIds.map((productCard) => {
    const productId = productCard.id;
    const productIndex = productCard.index; // Get the index from the productCard object
    return lookupProductData(productId, null)
      .then((productData) => {
        if (productData) { // Check if product data is valid
          productData.index = productIndex;
          return productData;
        } else {
          return null; // Return null if product is not found
        }
      })
      .catch((error) => {
        console.error('Error looking up product:', error);
        return null; // Return null if error occurs
      });
  });

  // Wait for all the promises in the promises array to resolve
  Promise.all(trackedProducts)
  .then((results) => {
    const filteredResults = results.filter((result) => result !== null).map(result => {
      const variantsArray = Object.values(result.item_variant);
      const matchedVariant = variantsArray.find(variant => variant.sku === result.item_master_sku);

      result.item_variant = matchedVariant ? matchedVariant.variant_title.toLowerCase().replace(/ /g, '_') : '';
      return result;
    });

    productList(filteredResults);
    localStorage.removeItem('trackedProductCardIds');

  }).catch((error) => {
    console.error('Error:', error);
  });
}

function camelToUnderscore(key) {
  if(key != "" && key != null){
    var result = key.trim().replace( /([A-Z])/g, "$1" );
    return result.split(' ').join('_').toLowerCase();
  }
  return "";
}

function trackProductEvent(value, view_type, status, items){
  dataLayer.push({ ecommerce: null });

  window.dataLayer.push({
    event: "view_item",
    ecommerce: {
      currency: window.QF.currency,
      value: value,
      view_type: view_type,
      item_status: status,
      items: items
    }
  });
}

if (window.templateName == "product") {
  // Lookup product data using lookupProductData function
  const productId = window.QF.product.id;
  const variant_id = window.QF.variant_id;
  const trackedProduct = lookupProductData(productId, null);

  trackedProduct.then((productData) => {
    // Check the item_variant IDs with the variant_id and remove the others
    // console.log('Product Data:', productData);
    if (productData.item_variant) {
      productData.item_variant = productData.item_variant[variant_id].variant_title;
    }

    if (window.QF.product.selling_plan_groups.length > 0) {
      productData.item_category5 = "subscription";
    } else {
      productData.item_category5 = "one_time";
    }

    trackProductEvent(
      productData.price, "page", window.QF.product_available, [ productData ]
    );
  }).catch((error) => {
    console.error('Error:', error);
  });
}

window.addEventListener('quickview_opened', function(event) {
  const itemPrice = event.detail.price;
  let itemStatus = null;
  if(event.detail.in_stock == "true"){
    itemStatus = "available";
  } else {
    itemStatus = "unavailable";
  }
  //console.log(event.detail)
  if(event.detail){
    trackProductEvent(itemPrice, "quick_view", itemStatus, [ event.detail ]);
  }
})


function productList(detail) {
  // Map through the detail items and add the actual index from the page
  const itemsWithIndex = detail.map((item) => {
    // Find the product's position on the page
    const productCards = document.querySelectorAll('.collection-grid .product-card, .search-grid .product-card');
    let pageIndex = -1;
    
    // Find the matching product card and get its index
    for (let i = 0; i < productCards.length; i++) {
      if (productCards[i].getAttribute('data-product-id') == item.item_id) {
        pageIndex = i;
        break;
      }
    }
    
    // Return the item with the actual page index added
    return {
      ...item,
      index: pageIndex !== -1 ? pageIndex : item.index // Use found index or keep existing
    };
  });

  const ecommerceData = {
    item_list_id: window.QF.page_handle || null,
    item_list_name: window.QF.page_title || null,
    item_list_lifestage: window.QF.filter_lifestage || "",
    item_list_product_type: window.QF.filter_product_type || "",
    item_list_range: window.QF.filter_range || "",
    item_list_special_diets: window.QF.filter_special_diets || "",
    item_list_packsize: window.QF.filter_packsize || "",
    item_list_flavour: window.QF.filter_flavour || "",
    item_list_sort: window.QF.sort_by || null,
    item_list_count: window.QF.products_count || null,
    items: itemsWithIndex
  };

  if (window.template === 'page.build-a-box' || window.template === 'page.build-a-box-landing') {
    ecommerceData.item_list_build_a_box = true;
    ecommerceData.item_list_bab_answers = window.QF.bab_answers || null;
  }

  dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "view_list_item",
    ecommerce: ecommerceData
  });

  if (window.template === 'search') {
    if (document.querySelector('.search-grid')) {
      dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "search",
        ecommerce: {
          search_keywords: document.querySelector('.search-grid').getAttribute('data-search-terms'),
          search_type: "main-search",
          items: itemsWithIndex
        }
      });
    }
  }

  // console.log('productList', detail);
}

if (window.QF.logged_in) {
  // check localstorage if userSignUp is true and userEmail is the same as the logged in user email
  const userSignUp = localStorage.getItem('userSignUp');
  const userEmail = localStorage.getItem('userEmail');
  if(userSignUp == 'true' && userEmail == window.QF.customer.email){
    dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "sign_up",
      ecommerce: {
        method: "create_account"
      }
    });

    // clear localstorage
    localStorage.removeItem('userSignUp');
    localStorage.removeItem('userEmail');
  }

  // Get local storage, if false then set to true and fire login event
  const userLoggedIn = localStorage.getItem('userLoggedIn');
  if (userLoggedIn == 'false' || userLoggedIn === null) {
    localStorage.setItem('userLoggedIn', true)
    window.dataLayer.push({
      event: "login",
      ecommerce: {
        method: "account_login"
      }
    });
  }

  // Fire logged in user event contain various attributes
  window.dataLayer.push({
    event: "user",
    user: {
      'user_status': "logged-in",
      'user_id': window.QF.customer ? window.QF.customer.id || null : null,
      'has_subscription': window.QF.has_subscription || null,
      'past_purchase': window.QF.past_purchase || null
    }
  });
} else {
  // If customer is not logged in then status is logged out
  window.dataLayer.push({
    event: "user",
    user: {
      'user_status': "logged-out"
    }
  });

  // Work out if a user is newly logged out and if they are fire the logout event
  const userLoggedIn = localStorage.getItem('userLoggedIn');
  if(userLoggedIn == 'true'){
    window.dataLayer.push({
      event: "logout",
    });
    localStorage.removeItem('userLoggedIn')
  }
}

// Listen for the user_signup event
document.addEventListener('user_signup', function(event) {
  dataLayer.push({ ecommerce: null });
  var dispatchedMethod  = "create_account";
  if(event.detail.method){
    dispatchedMethod  = event.detail.method;
  }
  window.dataLayer.push({
    event: "sign_up",
    ecommerce: {
      method: dispatchedMethod
    }
  });
});

document.addEventListener('modal_opened', function(event) {
  dataLayer.push({ ecommerce: null });
  var modalType  = "";
  if(event.detail.id){
    modalType  = event.detail.id;
  }
  window.dataLayer.push({
    event: "pop_up_type",
    ecommerce: {
      method: modalType
    }
  });
});

document.addEventListener('user_search', function(event) {
  dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "search",
    ecommerce: {
      search_keywords : event.detail.keyword
    }
  });
});

document.addEventListener('contact_us', function(event) {
  dataLayer.push({ ecommerce: null });
  var dispatchedType  = "contact";
  if(event.detail.type){
    dispatchedType  = event.detail.type;
  }
  window.dataLayer.push({
    event: "contact_us",
    ecommerce: {
      method: dispatchedType
    }
  });
});

// Track FAQ clicks across the whole site
document.addEventListener('click', function(event) {
  dataLayer.push({ ecommerce: null });
  const element = event.target.closest('.faq-accordion.active');
  if (element) {
    const parentGroup = event.target.closest('.accordion-faqs-group');
    const siblingH2 = parentGroup.querySelector('.question');

    if (siblingH2) {
      var category = parentGroup.querySelector('h2').textContent.trim();
      var question = event.target.textContent.trim();
      window.dataLayer.push({
        event: "select_faq",
        ecommerce: {
          category: category,
          questions: question
        }
      });
    }
  }
});

async function cartDataLayerPush(event, cartContents) {
  dataLayer.push({ ecommerce: null });
  var filtered = [];

  if (cartContents && cartContents.items) {
    const itemIds = cartContents.items.map(item => item.product_id);
    const trackedItems = itemIds.map(itemId => lookupProductData(itemId, null));

    Promise.all(trackedItems).then((itemData) => {
      for (var i = 0; i < cartContents.items.length; i++) {
        var cartItem = cartContents.items[i];
        var sellingPlanItem = "one_time|subscription";
        //console.log('cartItem.selling_plan_allocation', cartItem.selling_plan_allocation);
        if (cartItem.selling_plan_allocation && cartItem.selling_plan_allocation.selling_plan) {
          sellingPlanItem = "subscription";
        }
        var currentItemData = itemData[i];

        var item = {
          "item_id": cartItem.product_id,
          "item_name": cartItem.product_title,
          "index": i,
          "quantity": cartItem.quantity,
          "coupon": null,
          "discount": cartItem.total_discount,
          "item_list_id": currentItemData ? currentItemData.item_list_id : null,
          "item_list_name": currentItemData ? currentItemData.item_list_name : null,
          "item_category": cartItem.product_type,
          "item_category2": currentItemData ? currentItemData.item_category2 : null,
          "item_category3": currentItemData ? currentItemData.item_category3 : null,
          "item_category4": currentItemData ? currentItemData.item_category4 : null,
          "item_category5": sellingPlanItem,
          'item_category6': currentItemData ? currentItemData.item_category6 : null,
          "item_variant": camelToUnderscore(cartItem.variant_title),
          "price": parseFloat((cartItem.final_price / 100).toFixed(2)),
        };

        filtered.push(item);
      }

      var cartValue = 0;
      if (cartContents && cartContents.total_price) {
        cartValue = parseFloat((cartContents.total_price / 100).toFixed(2));
      }

      window.dataLayer.push({
        event: event,
        ecommerce: {
          currency: window.QF.currency,
          value: cartValue,
          items: filtered
        }
      });
    });
  }
}

// Cart viewed
window.addEventListener('side_cart_opened', function(event) {
  cartDataLayerPush("view_cart", event.detail.cart);
});

window.addEventListener('item_added', function(event) {
  dataLayer.push({ ecommerce: null });
  const cartItems = event.detail?.cart?.items;
  let newestCartItem = event.detail.newestItem;
  if(newestCartItem != null){
    newestCartItem = cartItems.find(item => item.id === parseInt(newestCartItem));

    let sellingPlan = "one_time";
    if(newestCartItem.selling_plan_allocation?.selling_plan?.id){
      sellingPlan = "subscription";
    }
    lookupProductData(newestCartItem.product_id, sellingPlan)
      .then((itemData) => {
        //console.log('event.detail',event.detail);
        const variantsArray = Object.values(itemData.item_variant);
        const matchedVariant = variantsArray.find(variant => variant.sku === itemData.item_master_sku);
        itemData.item_variant = matchedVariant ? matchedVariant.variant_title.toLowerCase().replace(/ /g, '_') : '';
        // const newestItem = event.detail.newestItem;
        const newestItem = event.detail.cart.items.find(item => item.id === parseInt(event.detail.newestItem));
        //console.log('newestItem', newestItem);
        itemData.index = event.detail.cart.items.findIndex(item => item.id === parseInt(event.detail.newestItem)) + 1;
        itemData.quantity = newestItem.quantity;
        window.dataLayer.push({
          event: "add_to_basket",
          ecommerce: {
            currency: window.QF.currency,
            value: itemData.price || '',
            items: [itemData]
          }
        });
      })
      .catch((error) => {
        console.error('Error:', error);
    });
  }
});

window.addEventListener('cart_item_removed', function(event) {
  dataLayer.push({ ecommerce: null });

  if(!event.detail.cart){
    event.detail.cart = null;
  }

  const product_id = event.detail.product_id;
  const variant_id = event.detail.variant_id;
  const quantity = event.detail.quantity;
  const index = event.detail.index;

  lookupProductData(product_id, null)
    .then((itemData) => {
      if (itemData.item_variant) {
        itemData.item_variant = itemData.item_variant[variant_id].variant_title;
      }
      itemData.index = parseInt(index);
      itemData.quantity = parseInt(quantity);

      window.dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          currency: window.QF.currency,
          value: itemData.price || '',
          items: [
            itemData
          ]
        }
      });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
});

// Form dispatching
if(window.location.hash && window.location.hash.startsWith('#')){
  var hash = window.location.hash;
  var windowparams = hash.replace('#','').split('&').reduce(function (res, item) {
    var parts = item.split('=');
    res[parts[0]] = parts[1];
    return res;
  }, {});

  if(windowparams) {
    for (const key in windowparams) {
      if(key == 'posted_successfully' && windowparams[key] == 'user_signup') {
        document.dispatchEvent(new CustomEvent('user_signup', { detail: { method: 'user_signup' }}));
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function(event) {
  document.body.addEventListener('click', function(e) {
    const productCard = e.target.closest('.product-card');
    if (productCard) {
      const href = productCard.getAttribute('href');
      const id = productCard.getAttribute('data-product-id');
      dataLayer.push({ ecommerce: null });

      if (e.target.closest('#predictive-search-results')) {
        window.dataLayer.push({
          event: "search",
          ecommerce: {
            search_keywords: document.getElementById('header-search').value,
            search_type: "predictive",
            search_item: href
          }
        });
      }

      if (document.querySelector('.search-grid')) {
        window.dataLayer.push({
          event: "search",
          ecommerce: {
            search_keywords: document.querySelector('.search-grid').getAttribute('data-search-terms'),
            search_type: "main-search",
            search_item: href
          }
        });
      }

      lookupProductData(id, null) // Use the lookupProductData function to get the item data
        .then((itemData) => {
          dataLayer.push({ ecommerce: null });
          // console.log('itemData:', itemData);
          const variantsArray = Object.values(itemData.item_variant);
          const matchedVariant = variantsArray.find(variant => variant.sku === itemData.item_master_sku);

          itemData.index = parseInt(productCard.getAttribute('data-index'));
          itemData.item_variant = matchedVariant ? matchedVariant.variant_title.toLowerCase().replace(/ /g, '_') : '';

          window.dataLayer.push({
            event: "select_item",
            ecommerce: {
              currency: window.QF.currency,
              value: itemData.price || '',
              items: [
                itemData
              ]
            }
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  });
});

// Function to replace hyphens with underscores in a string
function formatValues(str) {
  return typeof str === 'string' ? str.replace(/[- ]/g, '_').toLowerCase() : str;
}

// Event listener for 'find_my_food' event
window.addEventListener('find_my_food', function(event) {
  dataLayer.push({ ecommerce: null });
  let quizType = "feeding_plan";
  if (window.template === 'page.build-a-box' || window.template === 'page.build-a-box-landing') {
    quizType = "build_a_box";
  }
  dataLayer.push({ ecommerce: null });
  if(event.detail){
    window.dataLayer.push({
      event: "find_my_food",
      ecommerce: {
        find_my_food_breed: formatValues(event.detail.dog_breed),
        find_my_food_age: formatValues(event.detail.dog_age),
        find_my_food_weight_current: formatValues(event.detail.dog_weight_current),
        find_my_food_preferences: formatValues(event.detail.dog_preferences),
        find_my_food_favourites: formatValues(event.detail.dog_favourites),
        find_my_food_activity: formatValues(event.detail.dog_activity),
        find_my_food_recommendation: true,
        quiz_type: quizType,
      }
    });
  }
})

// Event listener for 'pet_passport' event
window.addEventListener('pet_passport', function(event) {
  dataLayer.push({ ecommerce: null });
  if(event.detail){
    window.dataLayer.push({
      event: "pet_passport",
      ecommerce: {
        pet_passport_breed: event.detail.dog_breed,
        pet_passport_age: event.detail.dog_age,
        pet_passport_weight_current: event.detail.dog_weight_current,
        pet_passport_preferences: event.detail.dog_preferences,
        pet_passport_favourites: event.detail.dog_favourites,
        pet_passport_activity: event.detail.dog_activity,
        pet_passport_recommendation: true,
        pet_passport_fur_siblings: event.detail.dog_siblings,
        pet_passport_info: [
          event.detail.dog_gender,
          event.detail.dog_rescue,
          event.detail.dog_neutered
        ].join('|'),
      }
    });
  }
})

window.addEventListener('item_added', function(event) {
  var _learnq = window._learnq || [];
  var cart = {
    total_price: event.detail.cart.total_price/100,
    $value: event.detail.cart.total_price/100,
    total_discount: event.detail.cart.total_discount,
    original_total_price: event.detail.cart.original_total_price/100,
    items: event.detail.cart.items
  }
  _learnq.push(['track', 'Added to Cart', cart]);
})

if(window.template == "404") {
  window.dataLayer.push({
    event: "exception",
    ecommerce: {
      description: "404",
      error_url: window.location.pathname
    }
  });
}
